import DxTagBox, { TagBoxRef } from 'devextreme-react/tag-box';
import React from 'react';

const dropDownOptions = {
	height: 450
};

export const TagBox: React.FC<any> = props => {
	const tagBoxRef = React.useRef<TagBoxRef>();

	const onValueChanged = e => {
		if (e.previousValue !== e.value) {
			props.data.setValue(e.value);
			tagBoxRef.current.instance().option('value', e.value);
		}
	};

	const { items } = props.data.column.editorOptions;

	return (
		<DxTagBox
			ref={tagBoxRef}
			defaultValue={props.data.value}
			onValueChanged={onValueChanged}
			items={items(props)}
			displayExpr="text"
			valueExpr="value"
			applyValueMode="useButtons"
			searchEnabled
			selectAllMode="allPages"
			showSelectionControls
			maxDisplayedTags={2}
			showMultiTagOnly={false}
			dropDownOptions={dropDownOptions}
		/>
	);
};
